export function EFXStreamLogo(props: any) {
    return (
        <svg
            width="280px"
            height="80px"
            viewBox="0 0 280 80"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <linearGradient x1="55.1737574%" y1="33.2934804%" x2="88.3979214%" y2="6.52173849%" id="linearGradient-1">
                    <stop stopColor="#A28F61" offset="0%"></stop>
                    <stop stopColor="#FADF9A" offset="81.0000002%"></stop>
                    <stop stopColor="#FAECAF" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="M端-X-Stream-设计稿" transform="translate(-48.000000, -437.000000)" fillRule="nonzero">
                    <g id="Frame-22" transform="translate(0.000000, 144.000000)">
                        <g id="Group-4" transform="translate(48.000000, 293.000000)">
                            <path
                                d="M58.418553,30.9101448 L75.9265705,30.9101448 L37.7124023,80 L99.4690158,24.7884048 L81.9726729,24.7884048 L106.005341,0 L83.1515396,0 L58.418553,30.9101448 Z"
                                id="路径"
                                fill="url(#linearGradient-1)"
                            ></path>
                            <path
                                d="M26.728937,52.8467903 L35.0043945,52.8467903 L19.0137366,24.7888184 L10.7382812,24.7888184 L26.728937,52.8467903 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M9.04580945,52.8463802 L20.005827,44.3710172 L17.2162169,39.4318848 L0,52.8463802 L9.04580945,52.8463802 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M36.428609,24.7888184 L25.550293,33.194615 L28.4682957,38.0062084 L45.7895622,24.7888184 L36.428609,24.7888184 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M57.9051285,41.9825411 L60.1578274,35.6984863 L38.5996182,35.6984863 L36.3469238,41.9825411 L57.9051285,41.9825411 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M102.946805,24.7888184 L100.635742,31.0728759 L113.790097,31.0728759 L105.806444,52.8467903 L112.261066,52.8467903 L120.244727,31.0728759 L133.399081,31.0728759 L135.721809,24.7888184 L102.946805,24.7888184 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M226.751996,24.7888184 L220.23901,24.7888184 L220.075603,24.9859199 C218.464866,26.9028292 217.134257,28.410076 216.083776,29.5076604 L195.424316,52.8467903 L203.092838,52.8467903 L220.775931,33.1366447 L223.927371,52.8467903 L231.058971,52.8467903 L227.557367,29.994617 L226.822025,25.2641827 L226.751996,24.7888184 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M253.94806,44.730848 L248.170418,24.7888184 L242.929679,24.7888184 L232.623291,52.846789 L239.077912,52.846789 L244.750509,37.3685274 L247.668512,47.8033087 L248.835713,52.4409893 L248.940775,52.8583813 L253.609579,52.8583813 L253.772987,52.7076554 L258.290049,48.2322929 L268.794859,37.9134563 L263.238988,52.846789 L269.693609,52.846789 L279.999996,24.7888184 L274.385744,24.7888184 L253.94806,44.730848 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M169.197395,24.7888184 L138.978553,24.7888184 L136.6675,31.0728759 L160.279978,31.0728759 L158.575874,35.6989645 L134.940038,35.6989645 L128.683838,52.8467903 L135.126794,52.8467903 L139.130295,41.9830198 L147.218992,41.9830198 L154.420622,52.8467903 L162.474322,52.8467903 L155.65787,41.9830198 L162.696093,41.9830198 L168.893929,25.5308488 L169.197395,24.7888184 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M163.851807,52.8462029 L194.187371,52.8462029 L196.486759,46.5969238 L166.139529,46.5969238 L163.851807,52.8462029 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M202.171049,31.0728765 L204.493786,24.7888184 L174.146556,24.7888184 L171.847168,31.0728765 L178.441847,31.0728765 L202.171049,31.0728765 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                            <path
                                d="M167.843506,41.9825411 L198.190736,41.9825411 L200.443443,35.6984863 L176.725907,35.6984863 L170.142894,35.6984863 L167.843506,41.9825411 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
